<template>
  <div class="content">
    <div class="skv-questions__row">
      <skv-questions @repeat="repeat" :key="qKey" :savedActiveTab="activeTab" />
      <div class="sticky">
        <RightAside
          v-if="
            asideItems &&
            asideItems.length &&
            (!NewRecommendations || !NewRecommendations.length)
          "
          :items="asideItems"
        />
        <RecMaterials
        :parent="{name: 'Системная красная волчанка', id: 0, type: 'Нозология'}"
              v-else-if="NewRecommendations && NewRecommendations.length"
            />
      </div>
    </div>
  </div>
</template>

<script>
import skvQuestions from "../../components/interactiveTests/skv-questions.vue";
import RightAside from "../../components/pageComponents/RightAside.vue";
import RecMaterials from "@/components/pageComponents/RecMaterials.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  components: { skvQuestions, RightAside, RecMaterials },
  name: "SKVQuestions",
  data: () => ({
    qKey: 0,
    activeTab: null,
  }),
  computed: {
    ...mapGetters(["NewRecommendations"]),
    asideItems() {
      return [
        {
          title: "Препараты АЗ",
          image_desktop: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/cardio-img/aside-1_small.jpg`,
          image: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/cardio-img/aside-1.jpg`,
          theme: "white",
          event: "medicationsClick",
          to: {
            name: "Medications",
            query: {
              therapeutic_areas: "Immunology",
              disease: "skv",
            },
          },
        },
        {
          title: "Мероприятия",
          image: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/cardio-img/aside-2.jpg`,
          image_desktop: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/cardio-img/aside-2_small.jpg`,
          links: [
            {
              event: "calendarClick",
              title: "Предстоящие",
              to: {
                name: "Events",
                query: {
                  therapeutic_areas: "Immunology",
                },
              },
            },
            {
              event: "calendarClick",
              title: "Архив",
              to: {
                name: "ArchiveEvents",
                query: {
                  therapeutic_areas: "Immunology",
                  disease: "skv",
                },
              },
            },
          ],
        },
        {
          title: "Библиотека",
          image: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/cardio-img/aside-3.jpg`,
          image_desktop: `https://storage.yandexcloud.net/${this.$root.backetName}/media/content/public/assets/img/cardio-img/aside-3_small.jpg`,
          links: [
            {
              event: "libClick",
              title: "Публикации",
              to: {
                name: "TextMaterials",
              },
            },
            {
              event: "libClick",
              title: "Видеоматериалы",
              to: {
                name: "VideoMaterials",
              },
            },
            {
              event: "libClick",
              title: "Подкасты",
              to: {
                name: "Podcasts",
              },
            },
          ],
          theme: "dark",
        },
      ];
    },
  },
  methods: {
    ...mapActions(["fetchNewRecommendations"]),
    repeat(activeTab) {
      this.activeTab = activeTab;
      this.qKey++;
    },
  },
  created() {
    this.fetchNewRecommendations({
      url: this.$route.path,
      without_rec_cards: 'false',
    });
  },
};
</script>

<style lang="scss" scoped>
.skv-questions {
  &__row {
    margin-top: 64px;
    display: grid;
    grid-template-columns: 1fr 280px;
    column-gap: 136px;
    align-items: flex-start;

    @media screen and (max-width: 1220px) {
      grid-template-columns: 100%;
      row-gap: 40px;
    }
  }
}

.sticky {
  @media screen and (min-width: 1221px) {
    position: sticky;
    top: 125px;
  }
}
</style>